export default "__VITE_ASSET__WOReWi5F__"